module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.58aef543.ttf";